module.exports = __webpack_public_path__ + "img/02-2方案收益.43621138.png";